<template>
    <div class="admin-dashboard">
        <h1 class="dashboard-title">Admin Dashboard</h1>
        <div class="dashboard-grid">
            <router-link 
                v-for="card in dashboardCards" 
                :key="card.path"
                :to="card.path" 
                class="dashboard-card"
                :class="card.class">
                <div class="card-icon" :style="{ background: card.iconColor }">
                    <i :class="card.icon"></i>
                </div>
                <div class="card-content">
                    <h3>{{ card.title }}</h3>
                    <p>{{ card.description }}</p>
                </div>
            </router-link>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DashboardView',
    data() {
        return {
            dashboardCards: [
                {
                    title: 'Payments',
                    description: 'Manage user transactions, deposits and withdrawals',
                    path: '/admin/payments',
                    icon: 'fas fa-money-bill-wave',
                    iconColor: '#2563eb',
                    class: 'card-payments'
                },
                {
                    title: 'Users',
                    description: 'View and manage user accounts',
                    path: '/admin/users',
                    icon: 'fas fa-users',
                    iconColor: '#059669',
                    class: 'card-users'
                },
                {
                    title: 'Tickets',
                    description: 'Manage support tickets and customer inquiries',
                    path: '/admin/tickets',
                    icon: 'fas fa-ticket-alt',
                    iconColor: '#f59e0b',
                    class: 'card-tickets'
                },
                {
                    title: 'Giveaways',
                    description: 'Manage giveaways',
                    path: '/admin/giveaways',
                    icon: 'fas fa-box',
                    iconColor: '#7c3aed',
                    class: 'card-giveaways'
                },
                {
                    title: 'Item Management',
                    description: 'Manage items',
                    path: '/admin/item-management',
                    icon: 'fas fa-box',
                    iconColor: '#7c3aed',
                    class: 'card-settings'
                },
                {
                    title: 'Settings',
                    description: 'Configure system settings and preferences',
                    path: '/admin/settings',
                    icon: 'fas fa-cog',
                    iconColor: '#dc2626',
                    class: 'card-settings'
                }
            ]
        }
    }
}
</script>

<style scoped>
.admin-dashboard {
    padding: 2rem;
    background: #1a1a1a;
    min-height: 100vh;
}

.dashboard-title {
    color: #fff;
    font-size: 2rem;
    font-weight: 600;
    margin-bottom: 2rem;
    padding-bottom: 1rem;
}

.dashboard-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 1.5rem;
}

.dashboard-card {
    background: linear-gradient(145deg, #222, #2a2a2a);
    border-radius: 16px;
    padding: 1.5rem;
    text-decoration: none;
    color: #fff;
    transition: all 0.3s ease;
    border: 2px solid transparent;
    display: flex;
    align-items: center;
    gap: 1.5rem;
}

.dashboard-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
}

.card-payments:hover {
    border-color: #2563eb;
}

.card-users:hover {
    border-color: #059669;
}

.card-tickets:hover {
    border-color: #f59e0b;
}

.card-giveaways:hover {
    border-color: #7c3aed;
}

.card-settings:hover {
    border-color: #dc2626;
}

.card-icon {
    width: 60px;
    height: 60px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.5rem;
    color: white;
}

.card-content {
    flex: 1;
}

.card-content h3 {
    font-size: 1.25rem;
    font-weight: 600;
    margin: 0 0 0.5rem 0;
}

.card-content p {
    color: #999;
    font-size: 0.875rem;
    margin: 0;
}

@media (max-width: 768px) {
    .admin-dashboard {
        padding: 1rem;
    }

    .dashboard-grid {
        grid-template-columns: 1fr;
    }

    .dashboard-card {
        padding: 1.25rem;
    }
}
</style> 